<template>
  <div>
    <div class="row beast-member-add" v-if="canEdit">
      <div class="alert col-12" :class="`alert-${alertStatus}`" v-if="alertMessage" v-text="alertMessage"></div>
      <div class="col-10">
        <div class="form-group">
          <label>Username</label>
          <input type="text" class="form-control" v-model="member.username"/>
        </div>
      </div>
      <div class="col-2">
        <div class="form-group text-center">
          <label>&nbsp;</label>
          <div class="btn-group btn-block">
            <button class="btn btn-success" @click="storeData">
              <font-awesome-icon :icon="faPlus"/>
            </button>
            <button class="btn btn-danger" @click="clearData">
              <font-awesome-icon :icon="faTimes"/>
            </button>
          </div>
        </div>
      </div>
    </div>
    <table class="table table-striped table-borderless beast-table">
      <thead>
      <tr>
        <th class="beast-table-name">Name</th>
        <th class="beast-table-edit" v-if="canEdit">Actions</th>
      </tr>
      </thead>
      <tbody>
      <tr v-bind:key="user.username"
          v-for="user in users.data">
        <td class="beast-table-name">
          <router-link :to="`/profile/${user.username}`">
            {{user.firstName}} {{user.lastName}} ({{user.username}})
          </router-link>
        </td>
        <td class="beast-table-edit" v-if="canEdit">
          <button class="btn btn-danger" @click="remove(user.username)">
            <font-awesome-icon :icon="faTimes"/>
          </button>
        </td>
      </tr>
      </tbody>
    </table>

    <pagination :current="users.page"
                :pages="users.pages"
                @pageChange="readData"/>
  </div>
</template>


<style scoped lang="scss">
  .beast-readonly-toggle {
    display: block;
    margin: auto;
    vertical-align: middle;
    cursor: pointer;
    font-size: 17pt;

    &.fa-toggle-on {
      color: $beast-green;
    }
  }
  .beast-table {
    .beast-table-name {
      width: 60%;
      vertical-align: middle;
      a {
        color: $beast-dark-gray;

        &:hover {
          color: $beast-green
        }
      }
    }
    .beast-table-readOnly {
      width: 20%;
      vertical-align: middle;
      text-align: center;
    }
    td.beast-table-readOnly{
      cursor: pointer;
      font-size: 17pt;

      .fa-toggle-on {
        color: $beast-green;
      }
    }
    .beast-table-edit {
      width:10%;
      vertical-align: middle;
      text-align: center;

      .btn {
        margin-right: 5px;
      }
    }
  }

  .beast-member-add {
    label {
      font-weight: bold;
    }
  }
</style>

<script>
import { faTimes, faPlus, faToggleOff, faToggleOn } from "@fortawesome/free-solid-svg-icons";

import Pagination from "../../components/utils/Pagination.vue";

export default {
  components: { Pagination },
  props: {
    org: Object,
    teamId: String
  },
  watch: {
    async org() {
      await this.readData();
    }
  },
  computed: {
    apiURL() {
      return `/organizations/${this.org.slug}/teams/${this.teamId}/users`;
    },
    canEdit() {
      return this.isMember && this.org.allowedToEdit;
    },
    isMember() {
      return this.$auth.check() && this.org && this.org.isMember;
    },
    faTimes() {
      return faTimes;
    },
    faPlus() {
      return faPlus;
    },
    faToggleOff() {
      return faToggleOff;
    },
    faToggleOn() {
      return faToggleOn;
    },
    readOnlyIcon() {
      return this.pkgInfo.readOnly
        ? faToggleOn
        : faToggleOff;
    }
  },
  data() {
    return {
      alertStatus: "success",
      alertMessage: "",
      users: {
        data: [],
        count: 0,
        page: 0,
        pages: 0,
        size: 0
      },
      member: {
        username: ""
      }
    };
  },
  methods: {
    async storeData() {
      try {
        await this.axios.post(this.apiURL, this.member);
        this.clearData();
        await this.readData();
      } catch (e) {
        this.alertStatus = "danger";
        this.alertMessage = this._extractErrors(e);
      } finally {
        setTimeout(() => {
          this.alertMessage = "";
        }, 2500);
      }
    },
    clearData() {
      this.member = {
        username: ""
      };
    },
    async readData(page = 1) {
      const queryParams = {
        params: {
          size: 10,
          page
        }
      };

      const response = await this.axios.get(this.apiURL, queryParams);
      this.users = response.data;
    },
    async remove(username) {
      try {
        await this.$dialog.confirm("Are you sure you want to delete the user?", {
          okText: "Yes",
          cancelText: "Cancel"
        });
        await this.axios.delete(this.apiURL, {
          data: {
            username
          }
        });
        this.alertStatus = "success";
        this.alertMessage = "Operation was successfully executed.";
        await this.readData();
      } catch (err) {
        this.alertStatus = "danger";
        this.alertMessage = this._extractErrors(err);
      } finally {
        setTimeout(() => {
          this.alertMessage = "";
        }, 3500);
      }
    },
    _extractErrors(err) {
      if (!err.response || !err.response.data) {
        return err.message;
      }

      return err.response.data.message;
    }
  },
  async beforeMount() {
    if (this.org.slug !== "") {
      await this.readData();
    }
  }
};
</script>
